// Script to prevent scrolling when selecting variants
(() => {
  // Disable scrolling to elements on focus
  function disableAutoScrollOnFocus() {
    // Override the native scrollIntoView method
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    
    Element.prototype.scrollIntoView = function(options) {
      // Check if this is a variant selector element
      const variantContainer = this.closest('.product-form__input--pill');
      const variantSelector = this.closest('variant-selects');
      
      if (variantContainer || variantSelector || 
          this.classList.contains('product-form__input') ||
          this.parentElement?.classList.contains('product-form__input')) {
        // Don't scroll for variant selectors
        return;
      }
      
      // Otherwise, use the original behavior
      return originalScrollIntoView.apply(this, arguments);
    };
  }
  
  // Override history methods
  function interceptHistoryMethods() {
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    // Store the scroll position
    let lastScrollY = window.scrollY;
    
    // Override pushState
    history.pushState = function() {
      lastScrollY = window.scrollY;
      const result = originalPushState.apply(this, arguments);
      
      // If the URL contains variant, restore scroll position
      if (arguments[2] && arguments[2].includes('variant=')) {
        setTimeout(() => window.scrollTo(0, lastScrollY), 0);
      }
      
      return result;
    };
    
    // Override replaceState
    history.replaceState = function() {
      lastScrollY = window.scrollY;
      const result = originalReplaceState.apply(this, arguments);
      
      // If the URL contains variant, restore scroll position
      if (arguments[2] && arguments[2].includes('variant=')) {
        setTimeout(() => window.scrollTo(0, lastScrollY), 0);
      }
      
      return result;
    };
  }
  
  // Set focus without scrolling
  function disableFocusScrollBehavior() {
    // Inject CSS to prevent focus scrolling
    const style = document.createElement('style');
    style.textContent = `
      html, body {
        scroll-behavior: auto !important;
      }
      
      .product-form__input--pill input:focus,
      .product-form__input--pill label:focus,
      variant-selects:focus,
      .product-form__input:focus {
        outline: auto !important;
      }
      
      @media screen and (max-width: 749px) {
        /* Additional mobile-specific fixes */
        .product__info-container {
          scroll-margin-top: 0 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Run all the fixes
  function applyFixes() {
    disableAutoScrollOnFocus();
    interceptHistoryMethods();
    disableFocusScrollBehavior();
    
    // Add event listener to prevent default on all variant selector clicks
    document.addEventListener('click', (e) => {
      const variantLabel = e.target.closest('.product-form__input--pill label');
      const variantInput = e.target.closest('.product-form__input--pill input');
      
      if (variantLabel || variantInput) {
        // Store position
        const scrollY = window.scrollY;
        
        // Restore after a short delay
        setTimeout(() => {
          window.scrollTo(0, scrollY);
        }, 10);
      }
    }, true);
  }
  
  // Execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes);
  } else {
    applyFixes();
  }
})(); 